<script>

export default {
  props: {
    contact: {type: Object, required: true},
  },

  data() {
    return {
      observed: this.$storage.observed,
      directChannel: this.$storage.getDirectChannel(this.contact.mmid)
    }
  },

  watch: {
    'observed.directChannels': function (newVal, oldVal) {
      let me = this
      setTimeout(function() {
        me.directChannel = me.$storage.getDirectChannel(me.contact.mmid)
      }, 500);
    }
  },

  methods: {
    contactDisplay(contact) {
      return `${contact.first_name} ${contact.last_name}`.trim() || contact.username
    }
  }
}

</script>

<template>

  <div class="card mb-2 p-2">
      <div>
      <span v-if="directChannel.numUnreadMessages" class="badge bg-danger float-end">{{directChannel.numUnreadMessages}}</span>
      <img :src="contact.profile_image" class="avatar mx-auto" />
      </div>
      <div class="card-body text-center">
        <h4 class="card-title mb-0">{{contactDisplay(contact)}}</h4>
        <div class="text-muted"><small>{{contact.username}}</small></div>
        <p v-if="contact.job_title" class="text-muted">
          <small>{{contact.job_title}}</small>
        </p>
        <p v-if="contact.company_name">
          {{contact.company_name}}
        </p>
      </div>
  </div>

</template>

<style scoped>

a { text-decoration:none}

.card {
  width: 10.7rem;
}

.avatar {
  height:100px;
  width:100px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

.badge { border-radius: .5rem}

</style>